import axios from 'axios';

const was = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
});

was.interceptors.request.use(
  (config) => {
    config.headers.lbcookie = encodeURIComponent(document.cookie);
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export {
  axios,
  was
}



// WEBPACK FOOTER //
// ./src/lib/axios.js